import { ApproveCompanyDetails } from './components/ApproveCompanyDetails';
import { FillCompanyDetails } from './components/FillCompanyDetails';
import { DefaultIncorporationTasks } from './default-incorporation';

export const INCORPORATION_DEFAULT_COMPONENT_MAP = {
  [DefaultIncorporationTasks.FILL_CORPORATION_DETAILS]: FillCompanyDetails,
  [DefaultIncorporationTasks.REVIEW_CORPORATION_DETAILS]: ApproveCompanyDetails,
};
